const STORAGE_KEY = 'qualz_login_lockout';

function normalizeEmail(email) {
  return (email || '').trim().toLowerCase();
}

export function saveLoginLockout(email, retryAfterSeconds) {
  const until = Date.now() + Math.max(1, retryAfterSeconds) * 1000;
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      email: normalizeEmail(email),
      until,
    }),
  );
  return until;
}

export function getLoginLockout(email) {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const { email: storedEmail, until } = JSON.parse(raw);
    if (storedEmail !== normalizeEmail(email)) {
      return null;
    }
    if (!until || Date.now() >= until) {
      clearLoginLockout();
      return null;
    }
    return until;
  } catch {
    return null;
  }
}

export function clearLoginLockout() {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function formatLockoutRemaining(untilMs) {
  const seconds = Math.max(0, Math.ceil((untilMs - Date.now()) / 1000));
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

export function parseLoginErrorDetail(error) {
  const detail = error?.response?.data?.detail;
  if (detail && typeof detail === 'object') {
    return detail;
  }
  return null;
}
